import { action, payload } from 'ts-action'
import { IUserCertificate } from '@network/models/user-certificate.model'
import { IError, IPayload } from '@network/models/global.model'

export const UserCertificatesFetching = action(
  'UserCertificatesFetching',
  payload<boolean>(),
)

export const GetUserCertificates = action(
  'GetUserCertificates',
  payload<IPayload<IUserCertificate[]>>(),
)

export const GetUserCertificatesErrors = action(
  'GetUserCertificatesErrors',
  payload<IError>(),
)
